module.exports = __webpack_public_path__ + "img/team-member-01.c61d7459.jpg";